<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
    <h4 class="modal-title" >{{TR "Darstellung konfigurieren"}}</h4>
</div>
<div class="js-dummy-xs hidden-xs"></div>
<div class="modal-body chart-config-dlg">
    <div class="js-selections">
    {{#if advancedMode}}
    {{!--  ADVANCED MODE   --}}

    {{!--  TABS  --}}
    <div class="panel-group" id="lines-adv">
      {{#each lines}}
      <div id="line-{{index}}-panel" class="panel panel-default js-chart-row" data-row-index="{{index}}">
        <div class="panel-heading">
          <h4 id="line-{{index}}-title" class="panel-title">
            <a
                id="line-{{index}}-link"
                data-toggle="collapse"
                {{#unless isSelected}}class="collapsed"{{/unless}}
                data-parent="#lines-adv"
                href="#chart-line-collapse{{index}}"
            >
            {{#if field}}
            <span style="color: {{color}};" class="chart-label-dot"><i class="fa fa-circle"></i></span>
            <span class="js-chart-label">{{CHART-LABEL 1}}</span>
            {{else}}
            <i class="fa fa-plus chart-add-plus"></i> {{TR "Hinzufügen"}}
            {{/if}}
            </a>
          </h4>
        </div>
        <div id="chart-line-collapse{{index}}" class="panel-collapse collapse {{#if isSelected}}in{{/if}}">
            <div class="row m-t-10">
                <div class="col-sm-1">
                    <button
                        id="color-{{index}}"
                        class="btn js-chart-select-row-color m-r-15"
                        style="background-color: {{color}}; color:white"
                        {{#unless field}}disabled{{/unless}}
                    >
                        <i class="fa fa-paint-brush"></i>
                    </button>
                    {{#COMPARE ../count '>' 1}}
                    <button id="ct-delete-{{index}}" class="btn btn-white pull-right js-delete visible-xs">
                        <i class="fa fa-trash"></i>
                    </button>
                    {{/COMPARE}}
                </div>
                <div class="col-sm-6">
                    {{#SELECT field}}
                    <select id="field-{{index}}" class="selectpicker js-input js-series" data-live-search="true"  data-style="btn-white">
                        {{#if showEmptySerie}}
                        <option value="">-</option>
                        {{/if}}
                        {{#each series}}
                            <option value={{field}}>{{TR_DATAPOINT ../deviceID name}}</option>
                        {{/each}}
                        {{#if hasSmartTempData}}
                        <optgroup label="{{TR "Smart Temp"}}">
                            {{#each smartTempData}}
                            <option value={{field}}>{{name}}</option>
                            {{/each}}
                        </optgroup>
                        {{/if}}
                        {{#if hasWeatherData}}
                        <optgroup label="{{TR "Wetterdaten"}}">
                            {{#each ../weatherData}}
                            <option value={{field}}>{{name}}</option>
                            {{/each}}
                        </optgroup>
                        {{/if}}
                    </select>
                    {{/SELECT}}
                    <br />
                </div>
                <div class="col-sm-4">
                    {{#DEVICE_SELECT deviceID}}
                    <select id="device-{{index}}" class="js-input js-device">
                    </select>
                    {{/DEVICE_SELECT}}
                </div>
                <div class="col-sm-1 hidden-xs">
                    {{#COMPARE ../count '>' 1}}
                    <button id="ct-delete-{{index}}" class="btn btn-white pull-right js-delete">
                        <i class="fa fa-trash"></i>
                    </button>
                    {{/COMPARE}}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-11 col-sm-offset-1">
                    <div class="checkbox checkbox-primary">
                        <input
                            class="js-cb-histogram js-checkbox-adv"
                            id="cb-histogram_{{index}}"
                            name="cb-histogram_{{index}}"
                            type="checkbox" {{#COMPARE style '==' 1}}checked="checked"{{/COMPARE}}
                        >
                        <label for="cb-histogram_{{index}}">{{TR "Als Balkendiagramm darstellen"}}</label>
                    </div>
                </div>
            </div>
            <div class="row m-t-10">
                <div class="col-sm-12">
                    <div class="checkbox checkbox-primary">
                        <input
                            class="js-checkbox-adv js-is-custom-label"
                            id="cb-label_{{index}}"
                            name="cb-label_{{index}}"
                            type="checkbox"
                            {{#if showCustomLabel}}checked="checked"{{/if}}
                        >
                        <label for="cb-label_{{index}}"><strong>{{TR "Beschriftung anpassen"}}</strong></label>
                    </div>
                </div>
            </div>
            {{#if showCustomLabel}}
            <div id="js-cb-label-content" class="row m-b-20">
                <div class="col-sm-11 col-sm-offset-1">
                    <input
                        id="custom-label-{{index}}"
                        type="text"
                        class="form-control js-input js-custom-label"
                        value="{{customLabel}}"
                        placeholder="{{CHART-LABEL 0}}"
                        {{#unless field}}disabled{{/unless}}
                    />
                </div>
            </div>
            {{/if}}
            <div class="row">
                <div class="col-sm-12">
                    <div class="checkbox checkbox-primary">
                        <input
                            id="js-cb-combine-value_{{index}}"
                            class="js-checkbox-adv js-is-operator"
                            name="cb-combine-value_{{index}}"
                            type="checkbox"
                            {{#if operator}}checked="checked"{{/if}}
                        >
                        <label for="js-cb-combine-value_{{index}}"><strong>{{TR "Mit anderem Wert kombinieren"}}</strong></label>
                    </div>
                </div>
            </div>
            {{#if operator}}
            <div id="js-cb-combine-value-content" class="row m-b-20">
                <div class="col-sm-1 col-sm-offset-1">
                    <div class="btn-group">
                        <button
                            id="op-btn-{{index}}"
                            type="button"
                            class="btn btn-white dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            {{#unless field}}disabled{{/unless}}
                        >
                            {{#if operator}}{{{CHART-OPERATOR operator}}}{{else}}+{{/if}}
                        </button>
                        <ul class="dropdown-menu" role="menu"  id="op-mnu-{{index}}">
                        {{#if operator}}
                            <li><a class="js-operator" data-op="">{{TR "Keine"}}</a></li>
                            <li class="divider"></li>
                        {{/if}}
                        {{#each ../operators}}
                            <li><a class="js-operator" data-op="{{value}}">{{{TR name}}}{{#if desc}} - {{TR desc}}{{/if}}</a></li>
                        {{/each}}
                        </ul>
                    </div>
                </div>
                <div class="col-sm-6">
                    {{#SELECT field2}}
                    <select
                        id="field2-{{index}}"
                        class="selectpicker js-input js-series2"
                        data-live-search="true"
                        data-style="btn-white"
                        {{#unless field}}disabled{{/unless}}
                    >
                        <option value="">-</option>
                        {{#each series2}}
                            <option value={{field}}>{{TR_DATAPOINT ../deviceID name}}</option>
                        {{/each}}
                        {{#if hasSmartTempData2}}
                        <optgroup label="{{TR "Smart Temp"}}">
                            {{#each smartTempData2}}
                            <option value={{field}}>{{name}}</option>
                            {{/each}}
                        </optgroup>
                        {{/if}}
                        {{#if hasWeatherData2}}
                        <optgroup label="{{TR "Wetterdaten"}}">
                            {{#each ../weatherData}}
                            <option value={{field}}>{{name}}</option>
                            {{/each}}
                        </optgroup>
                        {{/if}}
                    </select>
                    {{/SELECT}}
                </div>
                <div class="col-sm-4">
                    {{#DEVICE_SELECT device2ID}}
                    <select
                        id="device2-{{index}}"
                        class="js-input js-device2"
                        {{#unless field}}disabled{{/unless}}
                    >
                    </select>
                    {{/DEVICE_SELECT}}
                </div>
            </div>
            {{/if}}
            <div class="row">
                <div class="col-sm-12">
                    <div class="checkbox checkbox-primary">
                        <input
                            id="js-cb-prepare-data_{{index}}"
                            name="cb-prepare-data_{{index}}"
                            type="checkbox"
                            {{#COMPARE style '==' 1}}disabled="disabled"{{/COMPARE}}
                            class="js-checkbox-adv js-is-prepare-data"
                            {{#if showPrepareData}}checked="checked"{{/if}}
                        >
                        <label for="js-cb-prepare-data_{{index}}"><strong>{{TR "Datenaufbereitung anpassen"}}</strong></label>
                    </div>
                </div>
            </div>
            {{#if showPrepareData}}
            <div id="js-cb-prepare-data-content" class="row m-b-10">
                <div class="col-sm-6 col-sm-offset-2">
                    {{TR "Zeitintervall/-fenster"}}
                </div>
                <div class="col-sm-4">
                    {{#SELECT ../timeWindow}}
                    <select id="time-window-{{index}}"
                        class="selectpicker js-bar-time-window"
                        data-style="btn-white"
                        {{#if disableTimeWindow}}disabled{{/if}}
                    >
                        {{#each ../timeWindows}}
                        <option value="{{id}}">{{name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
            </div>
            {{#if showTimeWindowWarning}}
            <div id="js-cb-prepare-data-content-2" class="row m-b-10">
                <div class="col-sm-offset-2 col-xs-10">
                    <div class="alert alert-warning">{{TR "Wetterdaten werden mit einem festen Zeitfenster 1 Stunde aggregiert"}}</div>
                </div>
            </div>
            {{/if}}

            <div id="js-cb-prepare-data-content-2" class="row m-b-10">
                <div class="col-sm-6 col-sm-offset-2">
                    {{TR "Wertaggregation"}}
                </div>
                <div class="col-sm-4">
                    {{#SELECT aggregationFunc}}
                    <select
                        id="aggregation-func-{{index}}"
                        class="selectpicker js-input js-aggregation-func"
                        data-style="btn-white"
                        {{#unless field}}disabled{{/unless}}
                    >
                        {{#each ../aggregationFunc}}
                            <option value="{{value}}">{{name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
            </div>
            {{/if}}
            <!-- Time shift settings --> 
            <div class="row">
                <div class="col-sm-12">
                    <div class="checkbox checkbox-primary">
                        <input
                            id="js-cb-time-shift_{{index}}"
                            name="cb-time-shift_{{index}}"
                            type="checkbox"
                            class="js-checkbox-adv js-is-time-shift"
                            {{#if showTimeShift}}checked="checked"{{/if}}
                        >
                        <label for="js-cb-time-shift_{{index}}"><strong>{{TR "Zeitversatz"}}</strong></label>
                    </div>
                </div>
            </div>
            
            {{#if showTimeShift}}
            <div id="js-cb-prepare-data-content" class="row m-b-10">
                <div class="col-sm-6 col-sm-offset-2 m-b-10">
                    {{TR "Modus"}}
                </div>
                <div class="col-sm-4">
                    {{#SELECT timeShiftMode}}
                    <select id="time-shift-mode-{{index}}"
                        class="selectpicker js-time-shift-mode js-input m-b-10"
                        data-style="btn-white"
                    >
                        {{#each ../timeShiftModes}}
                        <option value="{{id}}">{{TR name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
                {{#COMPARE timeShiftMode '==' 1}}
                <div class="col-sm-6 col-sm-offset-2">
                    {{TR "Verschiebung"}}
                </div>
                <div class="col-sm-4">
                    {{#SELECT timeShiftDiff}}
                    <select id="time-shift-diff-{{index}}"
                        class="selectpicker js-time-shift-diff js-input"
                        data-style="btn-white"
                    >
                        {{#each ../timeShiftDiffs}}
                        <option value="{{id}}">{{name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
                <div class="col-sm-offset-8 col-sm-4 m-t-5">
                    {{#SELECT timeShiftDiffUnit}}
                    <select id="time-shift-diff-unit-{{index}}"
                        class="selectpicker js-time-shift-diff-unit js-input"
                        data-style="btn-white"
                    >
                        {{#each ../timeShiftDiffUnits}}
                        <option value="{{id}}">{{TR name}}</option>
                        {{/each}}
                    </select>
                    {{/SELECT}}
                </div>
                {{/COMPARE}}
                {{#COMPARE timeShiftMode '==' 2}}
                <div class="col-sm-6 col-sm-offset-2">
                    {{TR "Referenzdatum"}}
                </div>
                <div class="col-sm-4">
                    <div class="input-group date">
                        <input 
                            type="text" 
                            class="form-control input-sm js-datepicker js-time-shift-date js-input" 
                            value="{{timeShiftDate}}"
                        />
                        <span class="input-group-addon b-0 btn-white">
                            <i class="fa fa-calendar"></i>
                        </span>
                    </div>
                    <div class="input-group bootstrap-timepicker timepicker m-t-5">
                        <input 
                            type="text" 
                            class="form-control input-sm js-time-shift-time js-timepicker js-input" 
                            value="{{timeShiftTime}}"
                        />
                        <span class="input-group-addon b-0 btn-white">
                             <i class="fa fa-clock-o"></i>
                        </span>
                    </div>

                </div>
                {{/COMPARE}}
            </div>
            {{/if}}
            <div class="row m-t-10">
            &nbsp;
            </div>
        </div>
      </div>
      {{/each}}
    </div>

    {{else}}
    {{!--  SIMPLE MODE   --}}
        <div>
            {{#each lines}}
            <div class="row chart-select-row js-chart-row" data-row-index="{{index}}">
                <div class="col-xs-1 hidden-xs m-t-5">
                    <button
                        id="color-simple-{{index}}"
                        class="btn js-chart-select-row-color"
                        style="background-color: {{color}}; color:white"
                        {{#unless field}}disabled{{/unless}}
                    >
                        <i class="fa fa-paint-brush"></i>
                    </button>
                </div>
                <div class="col-sm-10 col-xs-12 m-t-5">
                    {{#SELECT field}}
                    <select id="field-simple-{{index}}" class="selectpicker js-input js-series" data-live-search="true" data-style="btn-white">
                            {{#if showEmptySerie}}
                            <option value="">-</option>
                            {{/if}}
                            {{#each series}}
                                <option value={{field}}>{{TR_DATAPOINT ../deviceID name}}</option>
                            {{/each}}
                        {{#if hasSmartTempData}}
                        <optgroup label="{{TR "Smart Temp"}}">
                            {{#each smartTempData}}
                            <option value={{field}}>{{name}}</option>
                            {{/each}}
                        </optgroup>
                        {{/if}}
                        {{#if hasWeatherData}}
                        <optgroup label="{{TR "Wetterdaten"}}">
                            {{#each ../weatherData}}
                            <option value={{field}}>{{name}}</option>
                            {{/each}}
                        </optgroup>
                        {{/if}}
                    </select>
                    {{/SELECT}}
                </div>
                <div class="col-xs-11 visible-xs m-t-5">
                    <button
                        id="color-simple-2-{{index}}"
                        class="btn js-chart-select-row-color"
                        style="background-color: {{color}}; color:white"
                        {{#unless field}}disabled{{/unless}}
                    >
                        <i class="fa fa-paint-brush"></i>
                    </button>
                </div>
                <div class="col-xs-1 m-t-5">
                    {{#if ../canDelete}}
                    {{#if field}}
                    <button class="btn btn-white js-chart-select-row-delete pull-right" id="delete-simple-{{index}}">
                        <i class="fa fa-trash"></i>
                    </button>
                    {{/if}}
                    {{/if}}
                </div>
                <div class="visible-xs m-t-5">&nbsp;</div>
            </div>
            {{/each}}
        </div>
    {{/if}}
        <div class="row m-t-20">
            <div class="col-sm-6 col-xs-12">
                <div class="checkbox checkbox-primary">
                    <input id="js-cb-only-this-device" name="cb-only-this-device" type="checkbox" {{#if onlyThisDevice}} checked {{/if}}>
                    <label for="js-cb-only-this-device">{{TR "Nur für dieses Gerät verwenden"}}</label>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button id="ct-advanced" type="button" class="btn btn-white pull-left">
        {{#if advancedMode}}
            {{TR "Einfacher Modus"}}
        {{else}}
            {{TR "Erweiterter Modus"}}
        {{/if}}
    </button>
    <button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button type="button" class="btn btn-primary" id="ct-save">{{TR "Speichern"}}</button>
</div>
